import { SeoLocale, SeoMetadata } from "../../http/protocol";
import { isFilled, toWebUrl } from "./seoFallback";

/** True when an OG image URL is entered but is not a valid http(s) address. */
export function hasOgImageError(value: SeoMetadata): boolean {
  return isFilled(value.ogImageUrl) && toWebUrl(value.ogImageUrl) === undefined;
}

/** True when any field of this locale has its own value rather than a fallback. */
export function hasOwnValue(value: SeoMetadata): boolean {
  return isFilled(value.title) || isFilled(value.description) || isFilled(value.keywords) || isFilled(value.ogImageUrl);
}

/** The locales with the default locale first, otherwise in their given order. */
export function defaultFirst(locales: SeoLocale[]): SeoLocale[] {
  return [...locales.filter((locale) => locale.defaultLocale), ...locales.filter((locale) => !locale.defaultLocale)];
}
